<!--
2023-06-29 YTW 邀请功能优化
-->
<template>
  <div class="main-content">
    <div class="fixWidth">
      <!--      <img :src="inviteBK" class="inviteBK" alt=""/>-->
      <TopBack :title="$t('lang.inviteFriends.Affiliate')" style="position: relative;z-index: 1;"/>
      <div class="checkPageBox">
        <div class="checkPageBg">
          <div v-if="(pageActive === 1 && sharingRedTag) || (pageActive === 0 && (subBtnStatus ===1 || btnStatus === 1)) && userInfo" :style="{'left': pageActive===0?(language==='IN'?76:79)+'vw':(language==='IN'?28.5:30)+'vw'}" class="redTag"></div>
          <div class="checkPageBar" :style="{'left': pageActive===0?0:50+'%'}"></div>
          <div @click="pageActive = 0" :style="{'color': pageActive===0?'#000':'#585858'}" :class="language==='IN'?'barTitleIN':'barTitle'">{{ $t('lang.inviteFriends.Sharing')}}
          </div>
          <div @click="pageActive = 1" :style="{'color': pageActive===1?'#000':'#585858'}" :class="language==='IN'?'barTitle1IN':'barTitle1'">{{ $t('lang.inviteFriends.BetRewards')}}

          </div>
        </div>
      </div>
      <div v-if="pageActive === 0">
        <div class="title-box">
          <div class="title-group">
            <div :class="whiteTitle" v-if="$store.state.locale==='EN'">
              <div>{{ $t('lang.inviteFriends.whiteTitle')[0] }}{{ $t('lang.account.currencyType') + '100' }}</div>
              <div>{{ $t('lang.inviteFriends.whiteTitle')[1] }}</div>
            </div>
            <div :class="whiteTitle" v-else>
              <div>{{ $t('lang.inviteFriends.whiteTitle')[0] }}</div>
              <div>{{ $t('lang.inviteFriends.whiteTitle')[1] }}{{
                  $t('lang.account.currencyType') + '100'
                }}{{ $t('lang.inviteFriends.whiteTitle')[2] }}
              </div>
            </div>
            <div :class="desc">
              <span v-for="(item, index) in $t('lang.inviteFriends.desc')" :key="index">{{ item }}</span>
            </div>
          </div>
        </div>
        <div class="gradient">
          <div class="goldenBox">
            <img :src="golden" alt="">
          </div>
          <div class="steps">
            <div class="step-group">
              <div class="step-item" v-for="(item,index) in $t('lang.inviteFriends.stepsList')" :key="'step'+index">
                <div class="img-item">
                  <img :src="stepsImg[index].img" class="stepImg"
                       :style="index===3?'margin:-0.85vw 0 0 -2.5vw;height:11.75vw':''">
                  <div class="stepText"
                       :style="{ marginTop: index===3 ? '0.19vw' : '', fontSize: $store.state.locale==='IN' ? '2.5vw' : '' }">
                    {{ item.text }}
                  </div>
                </div>
                <img :src="next" v-if="index<3" class="next">
              </div>
            </div>
          </div>
          <div class="btn-box">
            <div class="lines">
              <div class="line1"/>
              <div class="text">{{ $t('lang.inviteFriends.shareNow') }}</div>
              <div class="line2"/>
            </div>
            <div class="icons">
              <div @click="whatsappClick"><img :src="whatsapp" alt=""/>
                <span class="name">whatsapp</span>
              </div>
              <div @click="telegramClick"><img :src="telegram" alt=""/>
                <span class="name">telegram</span>
              </div>
              <div @click="facebookClick"><img :src="facebook" alt=""/>
                <span class="name">facebook</span>
              </div>
              <div @click="copyLinkClick"><img :src="copyLink" alt=""/>
                <span class="name">copy Link</span>
              </div>
            </div>
          </div>
        </div>
        <div class="sharingStarIcon" :style="{backgroundImage:'url('+require('../../assets/images/invite/rankListBg.png')+')'}" v-show="$store.state.sharingStarIcon && pageActive===0 && false" @click="goto('sharingStar')">
          <span>{{$t('lang.inviteFriends.rankList')}}</span>
        </div>
        <div v-if="0" class="agentIcon" :style="{backgroundImage:'url('+require('../../assets/images/invite/agent.png')+')'}" v-show="pageActive===0" @click="goto('landing4')">
          <span>{{$t('lang.inviteFriends.Agent')}}</span>
        </div>
        <div v-if="cashWheelIsStart" class="cashWheelIcon" :style="{backgroundImage:'url('+require('../../assets/images/cashWheel/logoIcon.png')+')'}" v-show="pageActive===0" @click="goto('cashWheel')">
          <div v-if="cashWheelRedDot" class="redDot"></div>
          <span>{{ $t('lang.cashWheel.get') }} ₹500</span>
        </div>
<!--        <div class="sharingStar" v-show="true" @click="goto('SharingStar')">-->
<!--          <img :src="sharingStarIcon" alt="sharingStarIcon">-->
<!--        </div>-->
        <div class="rewards" :style="{backgroundImage:'url('+require('../../assets/images/invite/line-box.png')+')'}">
          <div class="rewards-top">
            <div class="boxTitle"><span
              style="color: #F1DAB0;">&nbsp;&nbsp;●&nbsp;&nbsp;</span>{{ $t('lang.inviteFriends.rewards') }}
            </div>
            <div class="boxImage" @click="receiveDetails"><img :src="detail"></div>
          </div>
          <div class="RewardsFont">
            <div class="left">
              <div class="icon"><img :src="iconA" style="height: 4.5vw"/></div>
              <div class="title">
                {{
                  $t('lang.inviteFriends.RewardsFonts')[0].text[0] + ' ' + $t('lang.inviteFriends.RewardsFonts')[0].text[1]
                }}
              </div>
              <div class="amount"><span>{{ $t('lang.account.currencyType') }}</span>{{ RewardsFonts[0].amount }}</div>
            </div>
            <div class="center"><img :src="centerImg" style="width: 2px;"></div>
            <div class="right">
              <div class="icon"><img :src="iconB" style="height: 4.5vw"/></div>
              <div class="title">
                {{
                  $t('lang.inviteFriends.RewardsFonts')[2].text[0] + ' ' + $t('lang.inviteFriends.RewardsFonts')[2].text[1]
                }}
              </div>
              <div class="amount">{{ RewardsFonts[2].amount }}</div>
            </div>
          </div>
        </div>
        <div class="channel" @click="outLink">
          <img :src="channel"/>
          <div class="text"> {{ $t('lang.inviteFriends.channel') }}</div>
        </div>
      </div>
      <div v-if="pageActive === 1">
        <div class="title-box">
          <div class="title-group2">
            <img class="coins2" src="../../assets/images/account/coins2.png" alt="">
            <div :class="language==='IN'?'titleIN':'title'">{{ $t('lang.inviteFriends.whiteTitle2')}}</div>
            <div class="titleDescription">{{ $t('lang.inviteFriends.titleDescription')}}</div>
          </div>
        </div>
        <div class="betRewards">
          <div class="topImg"><img :src="circleLight"></div>
          <div class="topTitle">{{ $t('lang.inviteFriends.BetRewards') }}</div>
          <div class="group">
            <progressInvite
              v-if="gifts&&gifts.length>0"
              progressColor="1"
              :current="Math.floor(currentDegrees * 100) / 100"
              :gifts="gifts"
            />
          </div>
          <div class="bottom-tools" style="top: 11.8vw">
            <div class="bottomBtn" v-if="btnStatus!==3"
                 :style="btnStatus===1?'':'filter: grayscale(100%);color:#666666'"
                 @click="receiveInviteReward">
              <span>{{ $t('lang.inviteFriends.claim') }}</span>
            </div>
            <div class="lockBtn" v-else>
              <div><img :src="lock"/></div>
              <span :style="$store.state.locale === 'IN' ? 'font-size: 3.2vw; line-height: 4vw;' : ''">{{
                  $t('lang.inviteFriends.lockMsg').replace('{amount}', lockAmount)
                }}</span>
            </div>
          </div>
          <div :style="subShow?'height: 28vw':'height: 20vw'"/>
          <div v-if="subShow" class="sub-background">
            <div class="top-border"/>
          </div>
          <div v-if="subShow" class="sub-group">
            <div class="sub-title">
              <div><img :src="clock"/></div>
              <div class="title">{{ $t('lang.inviteFriends.timeLimited') }}</div>
            </div>
            <progressInvite
              v-if="subGifts&&subGifts.length>0"
              progressColor="2"
              :current="Math.floor(subCurrentDegrees * 100) / 100"
              :gifts="subGifts"
            />
          </div>
          <div v-if="subShow" class="bottom-tools" style="top: -7vw">
            <div class="bottomBtn" v-if="subBtnStatus!==3"
                 :style="subBtnStatus===1?'':'filter: grayscale(100%);color:#666666'"
                 @click="receiveSubInviteReward">
              <span>{{ $t('lang.inviteFriends.claim') }}</span>
            </div>
            <div class="lockBtn" v-else>
              <div><img :src="lock"/></div>
              <span :style="$store.state.locale === 'IN' ? 'font-size: 3.2vw; line-height: 4vw;' : ''">{{
                  $t('lang.inviteFriends.lockMsg').replace('{amount}', lockAmount)
                }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="steps" style="margin-top: 10vw">
        <div class="titleWhite">{{ $t('lang.agent.rules') }}</div>
        <div class="bubble-box">
          <div class="bubbleContent" v-for="(item,index) in $t('lang.inviteFriends.bubbleContent')" :key="index">
            <div class="spot">●</div>
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
      <div class="modal" v-if="isModalShowing">
        <div class="content">
          <div class="claimedTitle">
            {{ alertTitle }}
          </div>
          <div class="claimResult" v-html="alertFonts" :style="store.state.locale==='IN'?'font-size: 3.8vw;line-height:4.5vw':''"/>
          <div class="tips" v-if="tipShow&&(telegramAccount||phoneNum)">
            <div class="tip" v-if="telegramAccount">
              <div class="phoneNum">
                <div class="social"><img :src="plane"></div>
                <div class="number">{{ telegramAccount }}</div>
                <div class="copy"><img :src="copy" @click="copyNum(1)"/></div>
              </div>
              <div class="go" @click="addNum(0)">{{ $t('lang.luckyWheel.executeBtn') }}</div>
            </div>
            <div class="tip" v-if="phoneNum">
              <div class="phoneNum">
                <div class="social"><img :src="phone"></div>
                <div class="number">{{ phoneNum }}</div>
                <div class="copy"><img :src="copy" @click="copyNum(2)"/></div>
              </div>
              <div class="go" @click="addNum(1)">{{ $t('lang.luckyWheel.executeBtn') }}</div>
            </div>
          </div>
          <div class="button" v-if="alertType===1" @click="goto('Home')">{{
              $t('lang.betActivityRegularly.playNow')
            }}
          </div>
          <div class="cancel" v-if="alertType===1" @click="isModalShowing=false">{{
              $t('lang.betActivityRegularly.cancel')
            }}
          </div>
          <div class="cancel" v-else @click="isModalShowing=false">{{ $t('lang.inviteFriends.ok') }}</div>
        </div>
      </div>
    </div>
    <inviteUpdatePop
      v-if="inviteUpdatePop"
      @handleClose="closeInviteUpdatePop"
    />
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import TopBack from '@/components/TopBack/index'
import progressInvite from '@/components/ProgressLine/progressInvite'
import inviteBK from '@/assets/images/invite/inviteBK.png'
import detail from '@/assets/images/invite/detail.svg'
import golden from '@/assets/images/invite/golden.png'
import channel from '@/assets/images/invite/channel.png'
import centerImg from '@/assets/images/invite/centerImg.png'
import lock from '@/assets/images/invite/lock.svg'
import step1 from '@/assets/images/invite/step1.svg'
import step2 from '@/assets/images/invite/step2.svg'
import step3 from '@/assets/images/invite/step3.svg'
import step4 from '@/assets/images/invite/step4.svg'
import iconA from '@/assets/images/invite/iconA.svg'
import iconB from '@/assets/images/invite/iconB.svg'
import copyLink from '@/assets/images/invite/ic_copyLink.png'
import facebook from '@/assets/images/invite/ic_facebook.png'
import telegram from '@/assets/images/invite/ic_telegram.png'
import whatsapp from '@/assets/images/invite/ic_whatsapp.png'
import next from '@/assets/images/invite/next.svg'
import phone from '@/assets/images/invite/phone.svg'
import plane from '@/assets/images/invite/plane.svg'
import copy from '@/assets/images/invite/copy.svg'
import clock from '@/assets/images/invite/clock.svg'
import circleLight from '@/assets/images/invite/circleLight.png'
import sharingStarIcon from '@/assets/images/SharingStar/sharingButton.png'
import {Toast} from 'mint-ui'
import request from '@/service'
import store from '../../store/store'
import {fetchBalance, closePop, setCurrentModal} from '@/utils'
import inviteUpdatePop from '@/components/inviteUpdatePop'
export default {
  name: 'Earn',
  computed: {
    store () {
      return store
    },
    inviteUpdatePop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 17) {
          return modals[17].showing
        } else {
          return false
        }
      }
    }
  },
  data () {
    return {
      visitorCode: localStorage.getItem('visitorCode'),
      fetchBalance,
      language: localStorage.getItem('locale'),
      pageActive: 0,
      sharingRedTag: false,
      betRewardsRefTag: true,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      alertTemp: null,
      alertType: null,
      isModalShowing: false,
      RewardsFonts: [{amount: 0}, {amount: 0}, {amount: 0}],
      tipShow: false, // 显示管理员联系方式
      alertTitle: '',
      alertFonts: '',
      shareCode: '',
      amount1: 0,
      amount2: 0,
      amount3: 0,
      phoneNum: '',
      telegramAccount: '',
      btnStatus: 0,
      hasGotReward: false,
      lockAmount: 1,
      subBtnStatus: 0,
      whiteTitle: 'whiteTitle' + this.$store.state.locale,
      desc: 'desc' + this.$store.state.locale,
      startX: null,
      startY: null,
      touchDirection: null,
      currentDegrees: 0,
      subCurrentDegrees: 0,
      subShow: false,
      cashWheelRedDot: null,
      cashWheelIsStart: false,
      sharingStarIcon,
      copyLink,
      facebook,
      telegram,
      whatsapp,
      lock,
      step1,
      step2,
      step3,
      step4,
      iconA,
      iconB,
      next,
      copy,
      phone,
      plane,
      clock,
      circleLight,
      inviteBK,
      golden,
      detail,
      channel,
      centerImg,
      stepsImg: [
        {img: step1},
        {img: step2},
        {img: step3},
        {img: step4}
      ],
      gifts: [],
      subGifts: [],
      gift: 200
    }
  },
  components: {
    TopBack,
    progressInvite,
    inviteUpdatePop
  },
  watch: {
    '$store.state.locale': function (n, o) {
      this.language = localStorage.getItem('locale')
      if (n === 'EN') {
        this.whiteTitle = 'whiteTitleEN'
        this.desc = 'descEN'
      } else if (n === 'IN') {
        this.whiteTitle = 'whiteTitleIN'
        this.desc = 'descIN'
      }
      if (this.alertTemp !== null) {
        switch (this.alertType) {
          case 1:
            this.alertTitle = this.$t('lang.inviteFriends.congrats')
            this.alertFonts = this.$t('lang.inviteFriends.alert1').replace('{Times}', this.alertTemp.SettingTimes)
            break
          case 2:
            this.alertTitle = this.$t('lang.inviteFriends.success')
            this.alertFonts = this.$t('lang.inviteFriends.alert4').replace('{RewardAmount}', this.alertTemp.RewardAmount)
            break
        }
      }
    }
  },
  mounted () {
    if (this.$route.name && this.$route.name.toLocaleLowerCase() === 'earn' && store.state.modals[17].popupTimes < store.state.modals[17].maxPopupTimes) {
      setCurrentModal(17)
    }
    this.getViralityEnter()
    this.getCashWeelReddot()
    if (!this.userInfo) {
      this.fetchLocalAmount()
      this.getStaticData()
    } else {
      this.fetchAccount()
      this.fetchInviteData()
    }
    if (this.$store.state.locale === 'EN') {
      this.whiteTitle = 'whiteTitleEN'
      this.desc = 'descEN'
    } else if (this.$store.state.locale === 'IN') {
      this.whiteTitle = 'whiteTitleIN'
      this.desc = 'descIN'
    }
  },
  updated () {
  },
  methods: {
    ...mapMutations({
      setUserVerifyInfo: 'setUserVerifyInfo'
    }),
    closeInviteUpdatePop () {
      closePop(17)
    },
    imgShareClick () {
      this.saveUserEvent('ShareNow')
      this.$router.push('/Invite')
    },
    closePanel () {
      this.showPanel = false
    },
    getViralityEnter () {
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null,
        visitorCode: this.visitorCode
      }
      request('post', 'innovation/virality/status', data, false).then(res => {
        this.cashWheelIsStart = res
      })
    },
    getCashWeelReddot () {
      request('post', 'innovation/virality/get/collect/status', {userId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).UserId : null, visitorCode: this.visitorCode}).then(res => {
        if (res) {
          console.log(res)
          this.cashWheelRedDot = res.IsHaveUncollect
        }
      })
    },
    // msgFormat () {
    //   let welcomeMessage = this.$t('lang.inviteFriends.inviteMsg')
    //   let index = this.shareCode.indexOf('/Share')
    //   if (index === -1) {
    //     index = this.shareCode.toLowerCase().indexOf('/share')
    //   }
    //   if (index !== -1) {
    //     const pre = this.shareCode.substring(0, index)
    //     this.shareCode = this.shareCode.replace(pre, 'https://' + location.host)
    //   }
    //   welcomeMessage = welcomeMessage.replace('{shareURL}', this.shareCode)
    //   welcomeMessage = welcomeMessage.replace('{amount1}', this.amount1)
    //   welcomeMessage = welcomeMessage.replace('{amount2}', this.amount2)
    //   welcomeMessage = welcomeMessage.replace('{amount3}', this.amount3)
    //   return welcomeMessage
    // },
    msgFormat () {
      let welcomeMessage = this.$t('lang.sportsBetting.shareMsg')
      let index = this.shareCode.indexOf('/Share')
      if (index === -1) {
        index = this.shareCode.toLowerCase().indexOf('/share')
      }
      if (index !== -1) {
        const pre = this.shareCode.substring(0, index)
        this.shareCode = this.shareCode.replace(pre, 'https://' + location.host)
      }
      welcomeMessage = welcomeMessage.replace('{shareUrl}', this.shareCode)
      return welcomeMessage
    },
    telegramClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Telegram')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://t.me/share/url?text=` + message + `&url=%20`)
    },
    whatsappClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('WhatsApp')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://wa.me/?text=${message}`, '_blank')
    },
    facebookClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Facebook')
      this.copyShares()
      window.open(`https://www.facebook.com/sharer.php?u=` + this.shareCode, '_blank')
    },
    copyShares () {
      let message = this.msgFormat()
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', message)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
    },
    copyLinkClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.copyShares()
      this.saveUserEvent('Link2')
      Toast(this.$t('lang.inviteFriends.success'))
    },
    copyNum (index) {
      let shares = this.phoneNum
      if (index === 1) {
        shares = this.telegramAccount
      }
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', shares)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
      Toast(this.$t('lang.inviteFriends.success'))
    },
    addNum (index) {
      if (index === 0) {
        window.open('https://t.me/' + this.telegramAccount, '_blank')
      } else {
        window.open('http://wa.me/' + this.phoneNum, '_blank')
      }
    },
    fetchAccount () {
      let that = this
      const url = '/innovation/account/getuseraccount'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data).then(res => {
        that.shareCode = res.InviteLink
        that.fetchLocalAmount()
      }).catch(err => {
        console.log(err)
      })
    },
    outLink () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      window.location.href = 'https://t.me/+y6Swf0yJaNY0NWVl'
    },
    fetchLocalAmount () {
      const url = '/innovation/home/get-system-settings'
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      const data = {IsApp: 1, CampaignId: cid, userId: this.userInfo ? this.userInfo.UserId : ''}
      request('post', url, data).then(res => {
        this.amount1 = res.SevenDayReward
        this.amount2 = res.InviteeReward
        this.amount3 = res.FirstDepositMaxReward
        this.$store.commit('setInviteeObj',
          {
            sevenDayReward: res.SevenDayReward,
            inviteeMaxReward: res.DefaultCampaignIdFirstDepositMaxReward,
            InviteeReward: res.InviteeReward
          })
        this.$store.commit('setSharingStarIcon', res.InviteRankActivitySwitch)
      }).catch(err => {
        console.log(err)
      })
    },
    fetchInviteData () {
      const url = '/innovation/invite_relation/version_sub/get_invite_data'
      const data = {
        UserId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        this.hasGotReward = res.CompletedRewardBetAmount > 0
        this.btnStatus = res.ButtonStatus
        this.subBtnStatus = res.SubButtonStatus
        this.subShow = res.SubInviteesActivitySwith
        this.lockAmount = res.NeedMonthlyTaskValue
        // this.subShow = false
        this.currentDegrees = res.InviteesBetAmount / 100000
        this.subCurrentDegrees = res.SubInviteesBetAmount / 100000
        this.gifts = res.RewardFormulaList
        this.subGifts = res.SubRewardFormulaList
        this.RewardsFonts[0].amount = res.TotalRewards
        this.RewardsFonts[1].amount = res.RewardsAvailable
        this.RewardsFonts[2].amount = res.TotalInvited
        this.phoneNum = res.PhoneNumber
        this.telegramAccount = res.TelegramAccount
      }).catch(err => {
        console.log(err)
      })
    },
    receiveInviteReward () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      if (this.btnStatus !== 1) {
        return
      }
      const url = '/innovation/invite_relation/version_sub/receive_bet_reward'
      const data = {
        UserId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        this.subShow = res.SubInviteesActivitySwith
        this.tipShow = res.ContactAdministrator && res.RemainingTimes === 0
        this.hasGotReward = (res.RewardAmount + res.ManualRewardAmount) > 0 || res.ContactAdministrator
        if (res.RewardAmount > 0) {
          this.alertType = 2
          this.alertMsg(res.RewardAmount)
          this.fetchBalance()
        } else {
          this.alertType = 1
          this.alertMsg(res.RewardAmount, res.SettingTimes)
        }
        this.fetchInviteData()
      }).catch(err => {
        console.log(err)
      })
    },
    receiveSubInviteReward () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      if (this.subBtnStatus !== 1) {
        return
      }
      const url = '/innovation/invite_relation/version_sub/receive_sub_bet_reward'
      const data = {
        UserId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        this.subShow = res.SubInviteesActivitySwith
        this.tipShow = res.ContactAdministrator
        this.alertType = 1
        if (res.RewardAmount > 0) {
          this.alertType = 2
          // 单纯领取成功
          this.alertSubMsg(1)
          this.fetchBalance()
        } else if (res.CollectedDoneToday && res.RewardAmount === 0) {
          this.alertType = 1
          // 明天再来
          this.alertSubMsg(2)
        }
        this.fetchInviteData()
      }).catch(err => {
        console.log(err)
      })
    },
    receiveDetails () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      if (this.subShow) {
        localStorage.setItem('subShow', 'show')
      } else {
        localStorage.setItem('subShow', 'hide')
      }
      this.$router.push('/EarnDetails')
    },
    alertMsg (RewardAmount, SettingTimes) {
      if (!this.hasGotReward) {
        return
      }
      this.alertTemp = {RewardAmount: RewardAmount, SettingTimes: SettingTimes}
      switch (this.alertType) {
        case 1:
          this.alertTitle = this.$t('lang.inviteFriends.congrats')
          this.alertFonts = this.$t('lang.inviteFriends.alert1').replace('{Times}', SettingTimes)
          break
        case 2:
          this.alertTitle = this.$t('lang.inviteFriends.success')
          this.alertFonts = this.$t('lang.inviteFriends.alert4').replace('{RewardAmount}', RewardAmount)
          break
      }
      this.isModalShowing = true
    },
    alertSubMsg (type) {
      this.alertTemp = null
      switch (type) {
        case 1:
          this.alertTitle = this.$t('lang.inviteFriends.success')
          this.alertFonts = this.$t('lang.inviteFriends.alert2')
          break
        case 2:
          this.alertTitle = this.$t('lang.inviteFriends.sorry')
          this.alertFonts = this.$t('lang.inviteFriends.alert5')
          break
      }
      this.isModalShowing = true
    },
    getStaticData () {
      const url = '/innovation/invite_relation/not_login/get_invite_data'
      request('post', url, {}).then(r => {
        this.btnStatus = r.ButtonStatus
        this.subBtnStatus = r.SubButtonStatus
        this.subShow = r.SubInviteesActivitySwith
        this.lockAmount = r.NeedMonthlyTaskValue
        this.currentDegrees = r.InviteesBetAmount / 100000
        this.subCurrentDegrees = r.SubInviteesBetAmount / 100000
        this.gifts = r.RewardFormulaList
        this.subGifts = r.SubRewardFormulaList
        this.RewardsFonts[0].amount = r.TotalRewards
        this.RewardsFonts[1].amount = r.RewardsAvailable
        this.RewardsFonts[2].amount = r.TotalInvited
        this.phoneNum = r.PhoneNumber
        this.telegramAccount = r.TelegramAccount
      }).catch(err => {
        console.log(err)
      })
    },
    // 埋点
    saveUserEvent (val) {
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: val, UserUniqueId: this.userInfo.UserId}
      request('post', url, data).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    goto (label) {
      this.$router.push('/' + label)
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #161616;
  padding: 56px 0 0 0;
  overflow: hidden;

  .fixWidth {
    position: relative;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .checkPageBox {
    height: 9vw;
    //border: 1px solid red;
    display: flex;
    justify-content: center;
    margin-top: 2vw;

    .checkPageBg {
      width: 85vw;
      background: #000000DE;
      //background: red;
      border-radius: 8.88vw;
      position: relative;

      .redTag {
        background-color: #F23042;
        height: 2.2vw;
        width: 2.2vw;
        border-radius: 50vw;
        position: absolute;
        //left: 30vw;
        left: 79vw;
        z-index: 5;
        top: 2vw;
      }

      .checkPageBar {
        position: absolute;
        left: 0;
        height: 100%;
        width: 50%;
        border-radius: 8.88vw;
        background-image: linear-gradient(to right, #F7DEB8, #DEBC86); /* 从左到右的渐变 */
        //background: red;
        transition: left .3s;
      }

      .barTitle {
        position: absolute;
        color: #000;
        font-weight: 700;
        left: 13vw;
        top: 2.2vw;
      }
      .barTitleIN {
        position: absolute;
        color: #000;
        font-weight: 700;
        left: 15vw;
        top: 2.2vw;
      }

      .barTitle1 {
        position: absolute;
        color: #585858;
        font-weight: 700;
        right: 7vw;
        top: 2.2vw;
      }
      .barTitle1IN {
        position: absolute;
        color: #585858;
        font-weight: 700;
        right: 10vw;
        top: 2.2vw;
      }
    }
  }

  .inviteBK {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    z-index: 0;
  }

  .title-box {
    position: relative;
    top: 3vw;
    z-index: 1;

    .title-group {
      .whiteTitle {
        font-size: 9.5vw;
        font-weight: 700;
        line-height: 12.5vw;
        color: #ffffff;
        white-space: nowrap;
        text-align: center;
        margin-bottom: 1.5vh;
      }

      .whiteTitleEN {
        font-size: 9.5vw;
        font-weight: 700;
        line-height: 12.5vw;
        color: #ffffff;
        white-space: nowrap;
        text-align: center;
        margin-bottom: 1.5vh;
      }

      .whiteTitleIN {
        font-size: 6.75vw;
        font-weight: 700;
        line-height: 12.5vw;
        color: #ffffff;
        white-space: nowrap;
        text-align: center;
        margin-bottom: 1.5vh;
      }

      .descEN {
        font-size: 4.25vw;
        font-weight: 400;
        line-height: 4vw;
        color: #A6A6A6;
        white-space: nowrap;
        text-align: center;
        letter-spacing: -0.01em;
      }

      .descIN {
        font-size: 3vw;
        font-weight: 400;
        line-height: 6vw;
        letter-spacing: 0vw;
        color: #A6A6A6;
        white-space: nowrap;
        text-align: center;
      }
    }

    .title-group2 {
      //border: 1px solid red;
      padding: 7vw;
      position: relative;
      .coins2{
        position: absolute;
        width: 45.05vw;
        height: 50.61vw;
        top: 5vw;
        left: 55vw;
      }
      .title{
        font-weight: 700;
        color: #fff;
        font-size: 9.5vw;
      }
      .titleIN{
        font-weight: 700;
        color: #fff;
        font-size: 6.75vw;
      }
      .titleDescription{
        margin-top: 4vw;
        color: #A8A8A8;
        font-size: 4vw;
        width: 63vw;
      }
    }
  }

  .gradient {
    position: relative;
    left: 50%;
    top: 19.02vw;
    transform: translate(-50%);
    overflow: visible;
    display: block;
    justify-content: space-between;
    align-items: center;
    width: 89.366vw;
    height: 78.118vw;
    background: linear-gradient(to right bottom, #252A29, #345242);
    border-radius: 7.157vw;

    .goldenBox {
      position: absolute;
      top: -27vw;
      left: 50%;
      transform: translate(-50%);
      width: 75vw;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .steps {
      position: relative;
      left: 50%;
      top: 17vw;
      transform: translate(-50%);
      padding-left: 3.5vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 83.231vw;
      height: 27.4vw;
      background: rgba(28, 28, 28, 0.62);
      border-radius: 3.1vw;
      text-align: center;
      z-index: 1;

      img {
        width: 16.66vw;
        height: 2.61vh;
      }

      .step-group {
        display: flex;
        width: 100%;

        .step-item {
          display: flex;
          width: 25%;
          text-align: center;

          .img-item {
            width: 19vw;

            .stepImg {
              height: 11.111vw;
            }

            .stepText {
              width: 17vw;
              font-size: 3.27vw;
              color: #BFBFBF;
              font-weight: 700;
            }
          }

          .next {
            position: relative;
            top: 3vh;
            width: 3.32vw;
            height: 3vw;
            opacity: 0.25;
          }
        }
      }
    }

    .btn-box {
      position: relative;
      top: 20vw;
      left: 50%;
      transform: translate(-50%);
      z-index: 1;
      width: 80vw;

      .lines {
        position: relative;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .line1 {
          width: 22.29vw;
          height: 0.555vw;
          background: linear-gradient(270deg, #8D8D8D 0%, rgba(198, 198, 198, 0) 100%);
        }

        .line2 {
          width: 22.29vw;
          height: 0.555vw;
          background: linear-gradient(90deg, #8D8D8D 0%, rgba(198, 198, 198, 0) 100%);
        }

        .text {
          font-size: 5.93vw;
          font-weight: 700;
          letter-spacing: -0.035em;
          text-align: center;
          color: #EEEEEE;
          white-space: nowrap;
        }
      }

      .icons {
        position: relative;
        top: 3vw;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 72.746vw;
        height: 18.114vw;

        div {
          position: relative;
          display: block;
          width: max-content;
          height: 18.114vw;

          img {
            width: 13.206vw;
          }

          .name {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            font-weight: 400;
            font-size: 2.863vw;
            text-align: center;
            text-transform: capitalize;
            color: #FFFFFF;
            white-space: nowrap;
            text-shadow: 0.5px 0.5px 0 #000000,
            -0.5px 0.5px 0 #000000,
              0.5px -0.5px 0 #000000,
              -0.5px -0.5px 0 #000000,
            0px 0.5px 0 #000000,
              0px -0.5px 0 #000000,
            -0.5px 0px 0 #000000,
            0.5px 0px 0 #000000,
            0.5px 0.5px 0 #000000,
            -0.5px 0.5px 0 #000000,
              0.5px -0.5px 0 #000000,
              -0.5px -0.5px 0 #000000,
            0px 0.5px 0 #000000,
              0px -0.5px 0 #000000,
            -0.5px 0px 0 #000000,
            0.5px 0px 0 #000000,
            0.5px 0.5px 0 #000000,
            -0.5px 0.5px 0 #000000,
              0.5px -0.5px 0 #000000,
              -0.5px -0.5px 0 #000000,
            0.5px 0.5px 0 #000000,
            -0.5px 0.5px 0 #000000,
              0.5px -0.5px 0 #000000,
              -0.5px -0.5px 0 #000000
          }
        }
      }
    }
  }
  .cashWheelIcon{
    position: absolute;
    top: 39vw;
    right: 2vw;
    width: 12.85vw;
    height: 13vw;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 1.5vw;
    //border: 1px solid red;
    background-size: 100% 100%;
    .redDot{
      position: absolute;
      top: -0.5vw;
      right: -0.5vw;
      width: 6px;
      height: 6px;
      border-radius: 3px;
      background: radial-gradient(74.31% 74.31% at 31.38% 30.73%, #F9273A 0%, #982F39 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
      z-index: 3;;
      overflow: visible;
    }
    span{
      color: #A0A0A0;
      font-size: 2.2vw;
      margin-top: 10vw;
    }
  }
  .agentIcon{
    position: absolute;
    top: 24vw;
    right: 2vw;
    width: 12.85vw;
    height: 14vw;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 1.5vw;
    //border: 1px solid red;
    background-size: 100% 100%;
    span{
      color: #A0A0A0;
      font-size: 2.2vw;
      margin-top: 11vw;
    }
  }
  .sharingStarIcon{
    position: absolute;
    top: 24vw;
    right: 4vw;
    width: 13.85vw;
    height: 13.85vw;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 1.5vw;
    //border: 1px solid red;
    background-size: 100%;
    span{
      color: #A0A0A0;
      font-size: 2.2vw;
      margin-top: 10vw;
    }
  }
  .sharingStar {
    position: relative;
    left: 50%;
    top: 21.75vw;
    transform: translate(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 87.966vw;
    height: 18vw;
    overflow: hidden;
    border-radius: 4.08vw;
    z-index: 999;
    img {
      width: 89.366vw;
    }
  }

  .bubble-box {
    position: relative;
    top: 12vw;
    width: 100vw;
    height: max-content;
    background-color: #161616;
    padding-bottom: 20vw;

    .bubbleContent {
      display: flex;
      margin: auto;
      width: 81.2vw;
      font-size: 4.4vw;
      font-weight: 700;
      line-height: 3.14vh;
      text-align: left;
      color: #A69F9F;
      white-space: pre-wrap;

      .spot {
        margin: 0vh 2vw;
      }
    }
  }

  .titleWhite {
    position: relative;
    top: 8vw;
    left: 12vw;
    font-size: 6.5vw;
    font-weight: 700;
    color: #ffffff;
    text-align: left;
    z-index: 1;
  }

  .rewards {
    position: relative;
    top: 18vw;
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #222626;
    left: 50%;
    transform: translate(-50%);
    width: 89.366vw;
    height: 43.35vw;
    margin: 3vh 0vh;
    border-radius: 4.09vw;
    z-index: 1;

    .rewards-top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 7.8vw 0 5vw;

      .boxTitle {
        font-size: 5.521vw;
        font-weight: 700;
        line-height: 12vw;
        color: #ffffff;
        text-align: center;
        z-index: 1;
      }

      .boxImage {
        width: 5.226vw;
        padding-top: 0.75vw;

        img {
          width: 100%;
        }
      }
    }

    .RewardsFont {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      display: flex;
      width: 81.4vw;
      height: 25.766vw;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      background-color: #161616;
      border-radius: 3vw;

      .left {
        margin-left: 4.5vw;
      }

      .center {
        margin-left: 14.5vw;
      }

      .right {
        margin-left: 6vw;
      }

      .icon {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 2vw;
      }

      .title {
        font-size: 3.476vw;
        font-weight: 500;
        text-align: center;
        color: #6d6d6d;
      }

      .amount {
        margin-top: 0.75vw;
        font-size: 5.52vw;
        font-weight: 900;
        text-align: left;
        color: #FFFFFF;
      }
    }
  }

  .gifts {
    margin-top: 3vh;
    margin-left: 6vw;
    width: 90.46vw;
    z-index: 1;

    .levelFonts {
      display: flex;
      margin-left: -6.8vw;
      margin-bottom: 1vh;
      font-size: 4.91vw;
      font-weight: 700;
      line-height: 2.66vh;
      color: #F1DAB0;
      width: 100vw;

      .level-font {
        text-align: center;
        width: 17vw;
      }
    }

    .giftFonts {
      display: flex;
      margin-top: 1vh;
      font-size: 4.91vw;
      font-weight: 700;
      line-height: 2.66vh;
      letter-spacing: 0vw;
      text-align: left;
      color: #F1DAB0;
      width: 93.25vw;

      .gift-font {
        position: relative;
        width: 18vw;
        height: 15.5vw;
        text-align: center;

        .gift1, .gift2 {
          margin: auto;
          width: 6.92vw;
          height: 6.92vw;
        }

        .gift3 {
          margin-top: -0.63vh;
          /*margin-left: 4.5vw;*/
          /*margin-right: 6vw;*/
          width: 9.8vw;
          height: 9.8vw;
        }

        .giftAmount {
          position: absolute;
          left: -0.5vw;
          bottom: 0vh;
          color: #FFFFFF;
          width: 100%;
        }
      }
    }

    .level-line {
      margin-left: -2vw;
      width: 89vw;
      height: 3vh;
    }
  }

  .betRewards {
    position: relative;
    top: 5vw;
    left: 50%;
    transform: translate(-50%);
    width: 89.366vw;
    background: linear-gradient(to bottom, rgba(59, 67, 69, 0.66) 0%, rgba(58, 59, 52, 0.66) 100%);
    height: max-content;
    border-radius: 4vw;

    .group {
      position: relative;
      top: 5vw;
      left: 50%;
      transform: translate(-50%);
      background-color: rgba(0, 0, 0, 0.5);
      width: 92%;
      border-radius: 4vw;
      height: 25.76vw;
    }

    .sub-group {
      position: relative;
      top: -8vw;
      left: 50%;
      transform: translate(-50%);
      width: 92%;
      border-radius: 4vw;
      height: 40vw;

      .sub-title {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          margin-top: 1.2vw;
          width: 8vw;
        }

        .title {
          font-size: 5.112vw;
          font-weight: 700;
          color: #FFFFFF;
        }
      }
    }

    .sub-background {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 60vw;
      border-bottom-left-radius: 4vw;
      border-bottom-right-radius: 4vw;
      background: radial-gradient(46.59% 42.55% at 46.58% 44.76%, #232422 0%, #3D3714 100%);
      z-index: 0;

      .top-border {
        position: relative;
        top: 0;
        width: 100%;
        height: 0.4vw;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) -3.36%, #FFFFFF 54%, rgba(255, 255, 255, 0) 100.94%);
        opacity: 0.37;
      }
    }

    .topImg {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%);
      width: 65.687vw;

      img {
        width: 100%;
      }
    }

    .topTitle {
      position: relative;
      top: 2vw;
      left: 50%;
      transform: translate(-50%);
      width: 100%;
      text-align: center;
      font-size: 6.54vw;
      font-weight: 900;
      letter-spacing: -0.05em;
      color: #FFFFFF;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5), -2px -2px 4px rgba(0, 0, 0, 0.5)
    }

    .bottom-tools {
      position: relative;
      width: 67.28vw;
      height: 10.84vw;
      left: 50%;
      transform: translate(-50%);

      .bottomBtn {
        background: linear-gradient(to right, #F1DAB0 -10.06%, #F1DAB0 116.71%);
        width: 100%;
        height: 10.84vw;
        line-height: 10.84vw;
        text-align: center;
        color: #000000;
        font-size: 4.9vw;
        font-weight: 700;
        border-radius: 1.635vw;
        text-shadow: -0.5px -0.5px 1px rgba(0, 0, 0, 0.5)
      }

      .lockBtn {
        width: 100%;
        height: 10.84vw;
        border-radius: 1.635vw;
        background: rgba(0, 0, 0, 0.8);
        text-align: center;
        font-weight: 700;
        font-size: 3.885vw;
        line-height: 3.885vw;
        color: #F9F9F9;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        text-shadow: 0.5px -0.5px 1px rgba(255, 255, 255, 0.7);

        span {
          width: 45vw;
        }

        img {
          margin-left: 1vw;
          height: 7.222vw;
        }
      }
    }
  }

  .channel {
    position: relative;
    top: 15vw;
    left: 50%;
    transform: translate(-50%);
    width: 89.366vw;

    img {
      width: 100%;
    }

    .text {
      position: absolute;
      top: 0;
      line-height: 15.371vw;
      left: 16vw;
      font-weight: 700;
      font-size: 5.112vw;
      text-align: center;
      color: #FFFFFF;
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10;

    .content {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 81.18vw;
      height: max-content;
      padding: 3vw 6.66vw;
      border: 1px solid #737373;
      border-radius: 15px;
      margin: auto;
      background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;

      .claimedTitle {
        position: relative;
        text-align: center;
        color: #ffffff;
        height: 9.372vw;
        font-size: 6.13vw;
        font-weight: 700;
        line-height: 9.372vw;
      }

      .claimResult {
        margin-top: 2vw;
        width: 100%;
        height: 14vw;
        font-size: 4vw;
        font-weight: 400;
        color: #C4C4C4;
      }

      .tips {
        margin: 2vw auto 0 -4.3vw;
        padding: 1.5vw 0;
        font-size: 3.88vw;
        font-weight: 400;
        line-height: 20px;
        width: 75.869vw;
        background: rgba(0, 0, 0, 0.45);
        height: max-content;
        border-radius: 2vw;

        .tip {
          width: 75.869vw;
          height: 8vw;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 2.556vw;

          .phoneNum {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .social {
              height: 4.7vw;
              margin-right: 2vw;

              img {
                height: 100%;
              }
            }

            .number {
              font-size: 3.885vw;
              font-weight: 400;
              text-align: left;
              color: #FFFFFF;
              margin-right: 1vw;
            }

            .copy {
              height: 6vw;
              padding-top: 0.8vw;
              margin-right: 2vw;
              overflow: hidden;

              img {
                height: 6vw;
              }
            }
          }

          .go {
            width: 16.36vw;
            height: 6.135vw;
            line-height: 6.135vw;
            background: linear-gradient(0deg, #F1DAB0, #F1DAB0),
            linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
            text-align: center;
            font-size: 3.476vw;
            font-weight: 400;
            color: #000000;
            border-radius: 5.93vw;
          }
        }
      }

      .button {
        margin-top: 3vw;
        height: 10.42vw;
        line-height: 10.42vw;
        width: 100%;
        background: linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%),
        linear-gradient(0deg, #F1DAB0, #F1DAB0);
        border: none;
        border-radius: 8px;
        color: #220303;
        font-size: 5.3vw;
        font-weight: 700;
        text-align: center;
      }

      .cancel {
        margin-top: 3vw;
        width: 100%;
        text-align: center;
        font-size: 4.5vw;
        font-weight: 400;
        color: #696969;
      }
    }
  }
}

.fixWidth::-webkit-scrollbar {
  display: none
}

</style>



// WEBPACK FOOTER //
// src/pages/Invitee/index.vue